import { render, staticRenderFns } from "./Thankyou.vue?vue&type=template&id=dd94eeba&scoped=true&"
import script from "./Thankyou.vue?vue&type=script&lang=js&"
export * from "./Thankyou.vue?vue&type=script&lang=js&"
import style0 from "./Thankyou.vue?vue&type=style&index=0&id=dd94eeba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd94eeba",
  null
  
)

export default component.exports